import {
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
  CONFIGURATOR_PUBLIC_VIEWER_ROUTE_TEXTURE_V2,
  CONFIGURATOR_PUBLIC_VIEWER_ROUTE_V2,
  PRODUCT_360_VIEWER_PUBLIC_V2,
  PRODUCT_3D_VIEWER_PUBLIC_V2,
  PRODUCT_AI_VIDEO_PUBLIC_TEXTURE_V2,
  PRODUCT_AI_VIDEO_PUBLIC_V2,
  PRODUCT_AR_VIEWER_PUBLIC_V2,
  PRODUCT_VIDEO_PUBLIC_V2,
  TEXTURE_360_VIEWER_PUBLIC_V2,
  TEXTURE_3D_VIEWER_PUBLIC_V2,
  TEXTURE_VIDEO_PUBLIC,
} from '../../../constants/routePathConstants';
import { UpdateProductPublicShare, UpdateTexturePublicShare } from '../../../helpers/api';
import { errorToast, successToast } from '../../../helpers/toastHelper';
import { selectPdpProductDetails } from '../../../redux/slicers/productV2Slicer';
import { getAppState } from '../../../redux/store';

export const embedCopyConfigurator = ({
  productInfo,
  configuratorUrl,
  orgProductUniqueCodeId,
  copy,
  isIframe = true,
  isTexture = false,
}) => {
  if (!configuratorUrl || !orgProductUniqueCodeId) {
    errorToast('Unable to copy. Please try again later.');
    return;
  }
  const route = isTexture
    ? CONFIGURATOR_PUBLIC_VIEWER_ROUTE_TEXTURE_V2
    : CONFIGURATOR_PUBLIC_VIEWER_ROUTE_V2;
  const url = window.location.origin + route.replace(':modelId', configuratorUrl);
  const src = `${url}?unicode=${orgProductUniqueCodeId}`;
  if (isIframe) {
    const iframeCode = `<iframe style="border: none;" src="${src}" title="${productInfo?.name}" width="100%" height="768px" allowfullscreen></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  } else {
    copy(src);
    successToast('Link Copied');
  }
};

export const embedCopyArViewer = ({
  productInfo,
  orgProductUniqueCodeId,
  copy,
  isIframe = true,
}) => {
  if (!orgProductUniqueCodeId) {
    errorToast('Unable to copy. Please try again later.');
    return;
  }
  const src =
    window.location.origin + PRODUCT_AR_VIEWER_PUBLIC_V2.replace(':id', orgProductUniqueCodeId);
  if (isIframe) {
    const iframeCode = `<iframe style="border: none;" src="${src}" title="${productInfo?.name}" width="100%" height="768px" allowfullscreen></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  } else {
    copy(src);
    successToast('Link Copied');
  }
};

export const embedCopy3DViewer = ({
  productInfo,
  orgProductUniqueCodeId,
  copy,
  isIframe = true,
  isTexture = false,
}) => {
  if (!orgProductUniqueCodeId) {
    errorToast('Unable to copy. Please try again later.');
    return;
  }
  const _url = isTexture ? TEXTURE_3D_VIEWER_PUBLIC_V2 : PRODUCT_3D_VIEWER_PUBLIC_V2;
  const src = window.location.origin + _url.replace(':id', orgProductUniqueCodeId);
  if (isIframe) {
    const iframeCode = `<iframe style="border: none;" src="${src}" title="${productInfo?.name}" width="100%" height="768px" allowfullscreen></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  } else {
    copy(src);
    successToast('Link Copied');
  }
};

export const embedCopyVideo = async ({
  productInfo,
  orgProductUniqueCodeId,
  copy,
  isIframe = true,
  isTexture = false,
}) => {
  if (!orgProductUniqueCodeId) {
    errorToast('Unable to copy. Please try again later.');
    return;
  }
  const route = isTexture ? TEXTURE_VIDEO_PUBLIC : PRODUCT_VIDEO_PUBLIC_V2;
  const src = window.location.origin + route.replace(':id', orgProductUniqueCodeId);
  if (isIframe) {
    const iframeCode = `<iframe style="border: none;" src="${src}" title="${productInfo?.name}" width="100%" height="768px" allowfullscreen></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  } else {
    copy(src);
    successToast('Link Copied');
  }
};

export const embedCopyAIVideo = async ({
  productInfo,
  orgProductUniqueCodeId,
  copy,
  isIframe = true,
  isTexture = false,
}) => {
  if (!orgProductUniqueCodeId) {
    errorToast('Unable to copy. Please try again later.');
    return;
  }
  const route = isTexture ? PRODUCT_AI_VIDEO_PUBLIC_TEXTURE_V2 : PRODUCT_AI_VIDEO_PUBLIC_V2;
  const src = window.location.origin + route.replace(':id', orgProductUniqueCodeId);
  if (isIframe) {
    const iframeCode = `<iframe style="border: none;" src="${src}" title="${productInfo?.name}" width="100%" height="768px" allowfullscreen></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  } else {
    copy(src);
    successToast('Link Copied');
  }
};

export const embedCopy360Viewer = ({
  productInfo,
  orgProductUniqueCodeId,
  copy,
  isIframe = true,
  isTexture = false,
}) => {
  if (!orgProductUniqueCodeId) {
    errorToast('Unable to copy. Please try again later.');
    return;
  }
  const route = isTexture ? TEXTURE_360_VIEWER_PUBLIC_V2 : PRODUCT_360_VIEWER_PUBLIC_V2;
  const src = window.location.origin + route.replace(':id', orgProductUniqueCodeId);
  if (isIframe) {
    const iframeCode = `<iframe style="border: none;" src="${src}" title="${productInfo?.name}" width="100%" height="768px" allowfullscreen></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  } else {
    copy(src);
    successToast('Link Copied');
  }
};

export const updatePublicLinkProductTexture = ({ publicShare, productId, isTexture }) => {
  const productPageUrl = ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2.replaceAll(':id', '');
  const texturePageUrl = ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2.replaceAll(':id', '');
  let isValidPage = false;
  if (
    window.location?.pathname?.includes(productPageUrl) ||
    window.location?.pathname?.includes(texturePageUrl)
  ) {
    const url = new URL(window.location.href);
    const id = url.pathname.split('/').filter(Boolean).pop();
    productId = productId || id;
    isValidPage = true;
  }
  const isPublicLinkShared = publicShare || window.$shareFlag;
  if (!isPublicLinkShared || !productId || !isValidPage) return;
  const payload = {
    [isTexture ? 'texture' : 'product']: productId,
    is_publish: true,
    is_public: true,
  };
  const updateFunc = isTexture ? UpdateTexturePublicShare : UpdateProductPublicShare;
  updateFunc(payload);
};

export const isPdpProduct = () => {
  const pdpProductDetails = selectPdpProductDetails(getAppState());
  return Boolean(pdpProductDetails?.id);
}
  